import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { useModel as _useModel, mergeModels as _mergeModels } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "sort-title"
};
var _hoisted_2 = {
  key: 0,
  class: "sort-tips"
};
var _hoisted_3 = {
  class: "sort-content"
};
var _hoisted_4 = {
  class: "sort-left"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  class: "sort-right"
};
var _hoisted_7 = {
  class: "item-sort"
};
var _hoisted_8 = {
  class: "left-div"
};
var _hoisted_9 = {
  class: "img-div"
};
var _hoisted_10 = ["src"];
var _hoisted_11 = {
  class: "item-name"
};
var _hoisted_12 = {
  key: 0,
  class: "sub-item"
};
var _hoisted_13 = {
  class: "sub-left"
};
import draggable from 'vuedraggable';
import { ref, toRefs, watch, computed } from 'vue';
import { getAppSort, sortApp, getAppComponent, addAppComponent, delAppComponent, getAppPage } from '@/api/home.js';
import { MessagePlugin as message } from 'tdesign-vue-next';
import { routeAuth, appAliasEvent, appAliasInfo } from '@/utils/auth';
import { skipUrl as skipUrlOpen } from '@/util/util';
import { validateNull } from '@/util/validate';
import { getStore } from '@/util/store';
export default {
  __name: 'AppSortDialog',
  props: /*@__PURE__*/_mergeModels({
    tabType: {
      type: String,
      default: 'teacher'
    }
  }, {
    "sortVisible": false,
    "sortVisibleModifiers": {}
  }),
  emits: /*@__PURE__*/_mergeModels(['refresh'], ["update:sortVisible"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var _toRefs = toRefs(props),
      tabType = _toRefs.tabType;
    var emit = __emit;
    var visible = _useModel(__props, 'sortVisible', false);

    /** 初始化相关 */
    var accessToken = getStore({
      name: 'access_token'
    }); // 获取accessToken
    var appDatas = ref([]);
    var tab = ['应用排序', '小组件'];
    var currentIndex = ref(0);
    var componentList = ref([{
      name: '数据看板-互动数据',
      hasAuth: false,
      type: 1,
      icon: 'data-icon'
    }, {
      name: '群组',
      hasAuth: false,
      type: 3,
      icon: 'group-icon'
    }, {
      name: '常用应用',
      hasAuth: true,
      type: 2,
      icon: 'common-icon'
    }]);
    var canApplyApps = ref([]); // 可申请应用
    var applyApp = ref('');
    var hasApplyAppAuth = computed(function () {
      return !validateNull(applyApp.value);
    }); // 是否有 应用申请 应用权限
    var getApp = function getApp() {
      getAppSort(tabType.value).then(function (res) {
        if (res.data.code === 0) {
          appDatas.value = res.data.data || [];
        }
      });
    };
    watch(function () {
      return visible.value;
    }, /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var groupAuth, _yield$appAliasInfo, hasAuth, auth, dataAuth, index;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!val) {
                _context.n = 5;
                break;
              }
              getApp();
              _context.n = 1;
              return routeAuth('groupsSpace');
            case 1:
              groupAuth = _context.v;
              _context.n = 2;
              return appAliasInfo('dataView');
            case 2:
              _yield$appAliasInfo = _context.v;
              hasAuth = _yield$appAliasInfo.hasAuth;
              auth = _yield$appAliasInfo.auth;
              dataAuth = false;
              if (hasAuth && auth) {
                index = auth.findIndex(function (itm) {
                  return itm.permission.includes('interactiveData');
                });
                dataAuth = index > -1;
              }
              componentList.value[1].hasAuth = groupAuth;
              componentList.value[0].hasAuth = dataAuth;
              _context.n = 3;
              return getAppComponentList();
            case 3:
              getCanApplyApp();
              _context.n = 4;
              return appAliasEvent('applyApp', false);
            case 4:
              applyApp.value = _context.v;
            case 5:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      immediate: true
    });

    /** 事件相关 */
    /**
     * 获取可申请应用列表
     */
    var getCanApplyApp = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, _res$data, code, data;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                state: -1,
                memberType: 'manager'
              };
              _context2.n = 1;
              return getAppPage(params);
            case 1:
              res = _context2.v;
              _res$data = res.data, code = _res$data.code, data = _res$data.data;
              if (code === 0) {
                canApplyApps.value = data || [];
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getCanApplyApp() {
        return _ref3.apply(this, arguments);
      };
    }();
    /**
     * 申请更多应用
     */
    var goApplyMoreApp = function goApplyMoreApp() {
      // 前往应用权限申请与管理应用
      var url = "".concat(applyApp.value, "?token=").concat(accessToken);
      skipUrlOpen(url);
    };
    var onDragEnd = function onDragEnd() {
      console.log('拖拽结束', appDatas.value);
      handleSure();
    };
    /**
     * 确认
     */
    var handleSure = function handleSure() {
      var data = appDatas.value.map(function (i, index) {
        return {
          appId: i.appId,
          sort: index + 1
        };
      });
      sortApp(tabType.value, data).then(function (res) {
        if (res.data.code === 0) {
          message.success('调整成功');
          // visible.value = false;
        }
      });
    };
    var onClose = function onClose() {
      emit('refresh');
    };
    // 获取应用组件列表
    var getAppComponentList = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res, _res$data2, code, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return getAppComponent();
            case 1:
              res = _context3.v;
              _res$data2 = res.data, code = _res$data2.code, data = _res$data2.data;
              if (code === 0) {
                componentList.value = componentList.value.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    hasAdd: data.some(function (y) {
                      return y.type === x.type;
                    })
                  });
                });
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function getAppComponentList() {
        return _ref4.apply(this, arguments);
      };
    }();
    // 添加删除
    var handleOperation = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(item) {
        var type, hasAdd;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              type = item.type, hasAdd = item.hasAdd;
              if (!hasAdd) {
                _context4.n = 2;
                break;
              }
              _context4.n = 1;
              return delAppComponent({
                type: type
              });
            case 1:
              _context4.n = 3;
              break;
            case 2:
              _context4.n = 3;
              return addAppComponent({
                type: type
              });
            case 3:
              message.closeAll();
              message.success("".concat(hasAdd ? '移除' : '添加', "\u6210\u529F"));
              hasAdd ? item.hasAdd = false : item.hasAdd = true;
            case 4:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      return function handleOperation(_x2) {
        return _ref5.apply(this, arguments);
      };
    }();
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_dialog = _resolveComponent("t-dialog");
      return _openBlock(), _createBlock(_component_t_dialog, {
        visible: visible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return visible.value = $event;
        }),
        destroyOnClose: "",
        width: "560",
        class: "sort-dialog",
        footer: canApplyApps.value.length > 0 && hasApplyAppAuth.value,
        onClose: onClose
      }, {
        header: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_cache[2] || (_cache[2] = _createTextVNode(" 设置 ", -1)), currentIndex.value === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_2, "（长按应用可以拖动调整）")) : _createCommentVNode("", true)])];
        }),
        body: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(tab, function (item, index) {
            return _createElementVNode("div", {
              key: item,
              class: _normalizeClass(['tab-item', index === currentIndex.value && 'active']),
              onClick: function onClick($event) {
                return currentIndex.value = index;
              }
            }, _toDisplayString(item), 11, _hoisted_5);
          }), 64))]), _createElementVNode("div", _hoisted_6, [currentIndex.value === 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [!appDatas.value.length ? (_openBlock(), _createBlock(_component_t_loading, {
            key: 0,
            size: "small",
            class: "loading-div"
          })) : (_openBlock(), _createBlock(_unref(draggable), {
            key: 1,
            modelValue: appDatas.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return appDatas.value = $event;
            }),
            "item-key": "alias",
            class: "sort-list",
            onEnd: onDragEnd
          }, {
            item: _withCtx(function (_ref6) {
              var element = _ref6.element;
              return [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_svg_icon, {
                name: "move",
                class: "drag-icon"
              }), _createElementVNode("div", _hoisted_9, [_createElementVNode("img", {
                src: element.icon,
                alt: "",
                class: "img-icon"
              }, null, 8, _hoisted_10)]), _createElementVNode("span", _hoisted_11, _toDisplayString(element.appName), 1)])])];
            }),
            _: 1
          }, 8, ["modelValue"]))], 64)) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(componentList.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: index
            }, [item.hasAuth ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_svg_icon, {
              name: item.icon,
              size: "40px",
              class: "app-icon"
            }, null, 8, ["name"]), _createElementVNode("div", null, _toDisplayString(item.name), 1)]), _createVNode(_component_t_button, {
              variant: item.hasAdd ? 'outline' : 'base',
              theme: "primary",
              class: "sub-btn",
              onClick: function onClick($event) {
                return handleOperation(item);
              }
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.hasAdd ? '移除' : '添加'), 1)];
              }),
              _: 2
            }, 1032, ["variant", "onClick"])])) : _createCommentVNode("", true)]);
          }), 128))])])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "footer-text",
            onClick: goApplyMoreApp
          }, "申请更多应用")];
        }),
        _: 1
      }, 8, ["visible", "footer"]);
    };
  }
};